import Settings from './Settings.container';

export default Settings;
